export function getMaxEndDate(startDate, maxDays = 7) {
    if (!startDate) return null

    const date = new Date(startDate)
    date.setDate(date.getDate() + maxDays)

    return date.toISOString().substr(0, 10)
}